document.addEventListener("DOMContentLoaded", function() {
  const accordions = document.querySelectorAll('.Faq__single');

  accordions.forEach(accordion => {
      const heading = accordion.querySelector('.heading');
      const content = accordion.querySelector('.content');

      content.style.transition = "max-height 0.3s ease-out";
      content.style.overflow = "hidden";
      content.style.maxHeight = "0";

      heading.addEventListener('click', function() {
          const isActive = accordion.classList.toggle('active');
          content.style.maxHeight = isActive ? content.scrollHeight + "px" : "0";
      });
  });
});